export default __webpack_public_path__ + "static/media/Cloak of the Fortified Mind.07f15e18.jpg";